(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hc-banner-carousel').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('.hc-banner-track');let index=0;
const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return}if(document.hidden)return;index=(index+1)%track.children.length;track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});},3000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-hc-gallery]').forEach(gallery => {
  const track = gallery.querySelector('.hc-gallery-track');
  const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
  buttons.forEach((button, index) => button.addEventListener('click', () => {
    track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
  }));
  track.addEventListener('scroll', () => {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    buttons.forEach((button, position) => {
      if (position === index) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  }, {passive: true});
});

  } catch(e) { console.error(e); }
})();
})();
